import React from 'react';
import { Link } from 'react-router-dom'
import { Navbar, Icon} from 'react-materialize';
function Layout(props) {



  return (
    <React.Fragment>
      <header>
        <Navbar
          alignLinks="left"
          brand={<Link to="/calmyoga/" className="brand-logo" href="#"><span><div className='logo-yoga'></div></span></Link>}
          centerLogo
          id="mobile-nav"
          menuIcon={<Icon>❤</Icon>}
          options={{
            draggable: true,
            edge: 'left',
            inDuration: 250,
            onCloseEnd: null,
            onCloseStart: null,
            onOpenEnd: null,
            onOpenStart: null,
            outDuration: 200,
            preventScrolling: true
          }}
        >
          
            <Link to="/calmyoga/" className="Link" >Home</Link>

            <Link to="/lessons/" className="Link">Lessons</Link>
        
            <Link to="/contact/" className="Link">Contact</Link>
          

        </Navbar>
      </header>

      <main>
        {props.children}
      </main>

      <footer className="page-footer">
        <div className="container">
          <div className="row">
            <div className="col l6 s12">
              <h5 className="white-text">Calm Yoga</h5>
              <p className="grey-text text-lighten-4">Professional yoga service for all public.</p>
            </div>
            <div className="col l4 offset-l2 s12">
              <h5 className="white-text">Social networks</h5>
              <ul>
                <li><a className="grey-text text-lighten-3" href="https://devgrimaldo.com/" target="_blank" rel="noopener noreferrer">Facebook</a></li>
                <li><a className="grey-text text-lighten-3" href="https://devgrimaldo.com/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                <li><a className="grey-text text-lighten-3" href="https://devgrimaldo.com/" target="_blank" rel="noopener noreferrer">Linkedin</a></li>
                <li><a className="grey-text text-lighten-3" href="https://devgrimaldo.com/" target="_blank" rel="noopener noreferrer">Twitter</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <div className="container" style={{ textAlign: "center" }}>
            © 2022 Calm Yoga
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
}
export default Layout;